import __var_0__ from '@stdlib/math/base/assert/is-nan';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isnan = __var_0__;


// MAIN //

/**
* Returns the standard deviation of a degenerate distribution.
*
* @param {number} mu - constant value of distribution
* @returns {NonNegativeNumber} standard deviation
*
* @example
* var v = stdev( 0.1 );
* // returns 0.0
*
* @example
* var v = stdev( 0.5 );
* // returns 0.0
*
* @example
* var v = stdev( 10.0 );
* // returns 0.0
*
* @example
* var v = stdev( NaN );
* // returns NaN
*/
function stdev( mu ) {
	if ( isnan( mu ) ) {
		return NaN;
	}
	return 0.0;
}


// EXPORTS //
export default stdev;
